import { ApplicationElement, html } from '@beunity/lit-components';
import translations from './translations.js';
import style from './style.lit.css';

import '@beunity/lit-components/components/timeago/element.js';
import '@beunity/lit-components/components/icon/element.js';
import '@beunity/lit-components/components/icon_block/element.js';
import '@beunity/lit-components/components/grid_list/element.js';

/**
 * @prop createdAt - The date of cards creation.
 * @prop isOfficial - Is author an official user? (optional)
 * @prop publisher - Name of the publisher (username or group/community title)
 * @prop publisherUrl - URL to users profile, or URL to community/group
 *
 * @slot avatar - For avatar
 * @slot breadcrumbs - For breadcrumbs
 */
export class CardHeader extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];
  /** @internal */
  static translations = translations;

  static properties = {
    createdAt: { type: Date },
    isOfficial: { type: Boolean },
    publisher: { type: String },
    publisherUrl: { type: String },

    currentUserIsConfirmed: { type: Boolean, state: true, attribute: false },
  };

  get currentUserIsConfirmed() {
    return this._currentUserIsConfirmed || this.AppConfig?.user?.isConfirmed;
  }

  set currentUserIsConfirmed(value) {
    this._currentUserIsConfirmed = value;
  }

  requirePhoneConfirmation() {
    if (confirm('Are you phone confirmed?')) {
      alert('Great!');
      this.currentUserIsConfirmed = true;
    }
  }

  handleUserClick(e) {
    if (!this.currentUserIsConfirmed) {
      e.preventDefault();
      this.requirePhoneConfirmation();
    }
  }

  renderOfficialIcon() {
    return html` <ef-icon name="shield-check"></ef-icon> `;
  }

  render() {
    return html`
      <slot name="avatar"></slot>
      <div class="info">
        <div class="publisher">
          <a href=${this.publisherUrl} @click=${this.handleUserClick}>
            ${this.publisher}
          </a>
          ${this.isOfficial ? this.renderOfficialIcon() : null}
        </div>
        <div class="breadcrumbs">
          <slot name="breadcrumbs"></slot>
        </div>
        <ef-timeago timestamp="${this.createdAt}"></ef-timeago>
      </div>
    `;
  }
}

export default CardHeader;

CardHeader.registerTagName('bu-card-header');

customElements.get('bu-card-header') ||
  customElements.define('bu-card-header', CardHeader);
